<template>
  <el-form>
    <h2>Reset your password</h2>

    <el-form-item label="Password" :error="error" required>
      <el-input
        v-model="form.password"
        type="password"
        placeholder="Enter a new password"
      />

      <el-input
        v-model="form.confirm"
        type="password"
        class="confirm"
        placeholder="Confirm your password"
      />
    </el-form-item>

    <el-button
      type="primary"
      :loading="loading"
      @click.prevent="reset"
    >
      Submit
    </el-button>
  </el-form>
</template>

<script>
export default {
  props: {
    token: String
  },
  data () {
    return {
      loading: false,
      error: null,
      form: {
        token: this.token,
        password: null,
        confirm: null
      }
    }
  },
  methods: {
    reset () {
      if (!this.form.password || this.form.password !== this.form.confirm) {
        this.error = 'Your password is incorrect. Please check, and try again.'
        return
      }

      this.loading = true
      this.$store.dispatch('resetAccount', this.form).then(() => this.$router.push(this.$route.path))
        .catch(() => {
          this.loading = false
          this.error = 'The link has expired, please try again.'
        })
    }
  },
  watch: {
    token (value) {
      this.form.token = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .confirm {
    margin-top: 12px;
  }
</style>
